import React from 'react';
import { IconProps } from '.';

const SvgNumEightFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M2 5.333A3.333 3.333 0 0 1 5.333 2h13.334A3.333 3.333 0 0 1 22 5.333v13.334A3.333 3.333 0 0 1 18.667 22H5.333A3.333 3.333 0 0 1 2 18.667V5.333Z'
      />
      <path
        fill={secondaryColor}
        d='M11.993 16.575c2.149 0 3.698-1.133 3.698-2.67 0-1.184-.924-2.148-2.07-2.33v-.065a2.123 2.123 0 0 0 1.719-2.084c-.007-1.465-1.42-2.539-3.347-2.539s-3.34 1.074-3.333 2.54a2.08 2.08 0 0 0 1.719 2.083v.065c-1.172.182-2.083 1.146-2.083 2.33 0 1.537 1.543 2.67 3.697 2.67ZM10.34 13.71c-.007-.82.696-1.413 1.653-1.42.957.007 1.66.606 1.654 1.42.007.807-.658 1.374-1.654 1.367-.996.007-1.66-.56-1.653-1.367Zm.234-4.088c-.006-.736.573-1.25 1.42-1.25.84 0 1.425.514 1.432 1.25-.007.755-.606 1.282-1.433 1.289-.833-.007-1.425-.534-1.419-1.29Z'
      />
    </svg>
  );
};

export default SvgNumEightFill;
